import React from 'react';
import { FileTextIcon, MegaphoneIcon, MailIcon, TrendingUpIcon, CheckCircle2Icon, ArrowRightIcon, ActivityIcon } from 'lucide-react';
interface DashboardProps {
  onNavigate: (view: string) => void;
}
export function Dashboard({
  onNavigate
}: DashboardProps) {
  const stats = [{
    label: 'Productos Analizados',
    value: '3',
    icon: FileTextIcon,
    color: 'text-blue-500',
    bg: 'bg-blue-100'
  }, {
    label: 'Cartas Generadas',
    value: '12',
    icon: FileTextIcon,
    color: 'text-indigo-500',
    bg: 'bg-indigo-100'
  }, {
    label: 'Ads Creados',
    value: '45',
    icon: MegaphoneIcon,
    color: 'text-purple-500',
    bg: 'bg-purple-100'
  }, {
    label: 'Conversion Score Promedio',
    value: '87/100',
    icon: TrendingUpIcon,
    color: 'text-green-500',
    bg: 'bg-green-100'
  }];
  const quickActions = [{
    title: 'Analizar Nuevo Producto',
    desc: 'Sube tu eBook o URL para empezar',
    view: 'analyzer',
    icon: FileTextIcon
  }, {
    title: 'Crear Sales Letter',
    desc: 'Genera copy persuasivo en minutos',
    view: 'sales-letter',
    icon: FileTextIcon
  }, {
    title: 'Generar Ads',
    desc: 'Conceptos para Meta y TikTok',
    view: 'ads',
    icon: MegaphoneIcon
  }, {
    title: 'Secuencia de Emails',
    desc: 'Automatiza tus ventas',
    view: 'emails',
    icon: MailIcon
  }];
  const activities = [{
    action: 'Generó 5 variantes de Ads para',
    target: 'Ebook Postres Sin Culpa',
    time: 'Hace 2 horas'
  }, {
    action: 'Analizó el producto',
    target: 'Guía Food Truck Exitoso',
    time: 'Hace 5 horas'
  }, {
    action: 'Creó un Funnel Completo para',
    target: 'Recetario Keto Latino',
    time: 'Ayer'
  }];
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-236">
      <div data-id="element-237">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-238">
          Bienvenida de vuelta, Creadora 👋
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-239">
          Aquí está el resumen de tu motor de ventas gastronómico.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-240">
        {stats.map((stat, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex items-center gap-4" data-id="element-241">
            <div className={`p-3 rounded-lg ${stat.bg}`} data-id="element-242">
              <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-243" />
            </div>
            <div data-id="element-244">
              <p className="text-sm text-slate-500 font-medium" data-id="element-245">{stat.label}</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-246">{stat.value}</p>
            </div>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-247">
        {/* Quick Actions */}
        <div className="lg:col-span-2 space-y-6" data-id="element-248">
          <h2 className="text-lg font-semibold text-slate-900 flex items-center gap-2" data-id="element-249">
            <ActivityIcon className="w-5 h-5 text-indigo-500" data-id="element-250" />
            Acciones Rápidas
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-251">
            {quickActions.map((action, i) => <button key={i} onClick={() => onNavigate(action.view)} className="text-left bg-white p-5 rounded-xl shadow-sm border border-slate-100 hover:border-indigo-300 hover:shadow-md transition-all group" data-id="element-252">
                <div className="flex justify-between items-start mb-4" data-id="element-253">
                  <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg group-hover:bg-indigo-600 group-hover:text-white transition-colors" data-id="element-254">
                    <action.icon className="w-5 h-5" data-id="element-255" />
                  </div>
                  <ArrowRightIcon className="w-5 h-5 text-slate-300 group-hover:text-indigo-500 transition-colors" data-id="element-256" />
                </div>
                <h3 className="font-semibold text-slate-900" data-id="element-257">{action.title}</h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-258">{action.desc}</p>
              </button>)}
          </div>
        </div>

        {/* Sidebar content */}
        <div className="space-y-8" data-id="element-259">
          {/* Checklist */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-260">
            <h2 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-261">
              Primeros Pasos
            </h2>
            <div className="space-y-4" data-id="element-262">
              {[{
              text: 'Sube tu primer producto',
              done: true
            }, {
              text: 'Calibra tu Voz de Marca',
              done: true
            }, {
              text: 'Genera tu primera Sales Letter',
              done: false
            }, {
              text: 'Crea una campaña de Ads',
              done: false
            }].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-263">
                  <CheckCircle2Icon className={`w-5 h-5 mt-0.5 shrink-0 ${item.done ? 'text-green-500' : 'text-slate-300'}`} data-id="element-264" />
                  <span className={`text-sm ${item.done ? 'text-slate-500 line-through' : 'text-slate-700 font-medium'}`} data-id="element-265">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Activity Feed */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-266">
            <h2 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-267">
              Actividad Reciente
            </h2>
            <div className="space-y-5" data-id="element-268">
              {activities.map((act, i) => <div key={i} className="relative pl-4 border-l-2 border-slate-100 last:border-transparent pb-1" data-id="element-269">
                  <div className="absolute -left-[5px] top-1.5 w-2 h-2 rounded-full bg-indigo-400" data-id="element-270"></div>
                  <p className="text-sm text-slate-600" data-id="element-271">
                    {act.action}{' '}
                    <span className="font-medium text-slate-900" data-id="element-272">
                      {act.target}
                    </span>
                  </p>
                  <p className="text-xs text-slate-400 mt-1" data-id="element-273">{act.time}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}